'use client'

import Link from 'next/link'
import { LuShoppingCart, LuUser } from 'react-icons/lu'

import { cn } from '@/core/utils/common'
import { useViewer } from '@/features/viewer/hooks/use-viewer'

import type { Route } from 'next'

const ICON_LINK =
  'inline-flex h-11 items-center gap-1.5 px-2 text-c15 font-medium hover:text-point'

export function HeaderVehicle() {
  const { viewer } = useViewer()
  if (!viewer?.vehicle) return null
  return (
    <Link
      href={`/products?vehicle=${viewer.vehicle.id}` as Route}
      className="mr-2 hidden whitespace-nowrap text-c15 font-semibold text-point hover:underline over12:inline"
    >
      내 차 {viewer.vehicle.name}
    </Link>
  )
}

export function HeaderAccount() {
  const { viewer, isLoading } = useViewer()
  const label = viewer?.signedIn ? '마이페이지' : '로그인'
  return (
    <Link
      href={viewer?.signedIn ? '/mypage' : '/login'}
      aria-label={label}
      className={ICON_LINK}
    >
      <LuUser aria-hidden="true" className="size-6" />
      <span
        className={cn(
          'hidden over10:inline',
          isLoading && !viewer && 'invisible'
        )}
      >
        {label}
      </span>
    </Link>
  )
}

export function HeaderCart() {
  const { viewer } = useViewer()
  const count = viewer?.cartCount ?? 0
  return (
    <Link href="/cart" aria-label={`장바구니 ${count}개`} className={ICON_LINK}>
      <span className="relative">
        <LuShoppingCart aria-hidden="true" className="size-6" />
        {count > 0 && (
          <span
            aria-hidden="true"
            className="absolute -right-2 -top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-point px-1 text-c10 font-semibold tabular-nums text-inverse"
          >
            {count}
          </span>
        )}
      </span>
      <span className="ml-1 hidden over10:inline">장바구니</span>
    </Link>
  )
}
